import React, { useState } from "react";
import { Page, Spinner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import UnsignedAssignedDocuments from "components/unsigned-assigned-documents/unsigned-assigned-documents";

function UnsignedFilesContainer() {
  const { t } = useTranslation();
  const [isRefreshing, setIsRefreshing] = useState(false);

  return (
    <Page
      fullWidth
      title={t("unsigned_assigned_documents")}
      titleMetadata={
        isRefreshing ? (
          <Spinner size="small" accessibilityLabel={t("loading")} />
        ) : undefined
      }
    >
      <UnsignedAssignedDocuments onRefreshingChange={setIsRefreshing} />
    </Page>
  );
}

export default UnsignedFilesContainer;
